export const SENTRY_DSN_URL =
  'https://b49c510ba4e55e9113f8436cfcf70688@o1100855.ingest.us.sentry.io/4506891593187328';
